// src/hooks/useDownload.js
import { useState } from 'react';

export const useDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState(null);

  const downloadFile = async (url, defaultFilename = 'documento.pdf') => {
    setIsDownloading(true);
    setError(null);

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error en la descarga: ${response.statusText}`);
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      // Intenta extraer el nombre del archivo de la URL si no se proporciona uno específico
      const fileName = url.substring(url.lastIndexOf('/') + 1) || defaultFilename;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      // Limpieza
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Error al descargar el archivo:', err);
      setError(err.message);
      // Fallback: abrir en nueva pestaña
      window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadFile, isDownloading, error };
};